import React from 'react';

const Footer = () => (
  <div className="mt-24">
    <p className="dark:text-gray-200 text-gray-700 text-center m-20">
      © 2025 All rights reserved by <a className='text-blue-500' href="https://ajaykhati.netlify.app" target='_blank' rel="noreferrer">AjaySingh</a>
    </p>
  </div>
);

export default Footer;
